import { useSelector } from 'react-redux'
import { Input } from 'antd'
import {
  faIdBadge,
  faIdCard,
  faLocationArrow,
  faSchool
} from '@fortawesome/pro-solid-svg-icons'

import { selectTranslate } from '../../../../reducers/LocaleReducer/LocalReducer'
import FormItem from '../../../../Components/shared/Forms/FormItem'
import { School, SchoolProperties } from '../../../../utils/entities/school'
import { getEntityOrNull, getIdOrNull } from '../../../../utils'
import SchoolsSelector from '../../../../Components/shared/Selectors/School/SchoolsSelector'

const { ABBREVIATION, ADDRESS, NAME } = SchoolProperties

const SchoolSelector = ({ data, displayTitle, errorFields = [], schools, title, onChange }) => {
  const t = useSelector(selectTranslate)

  const handleSelectSchool = (value, _, entity) => onChange(new School({ ...data, ...getEntityOrNull(entity) ?? getEntityOrNull(value) }))

  const className = field => errorFields.includes(field) ? 'error-ant-border' : ''

  return (
    <>
      {displayTitle && <h3 className='pdl-12'> {t('common.school')}</h3>}

      <div className='pd-12'>

        <FormItem icon={faSchool} label={title || 'common.school.dd'} className={'form-select ' + className('id')} required>
          <SchoolsSelector
            className='pd-12'
            schools={schools}
            multiple='default'
            values={getIdOrNull(data) !== -1 ? getIdOrNull(data) : null}
            onChange={handleSelectSchool}
          />
        </FormItem>
        <div className='flex-fill' />
        <FormItem icon={faIdCard} label='common.name.dd'>
          <Input disabled value={data[NAME] ?? null} />
        </FormItem>
        <FormItem icon={faIdBadge} label='common.abbreviation.dd'>
          <Input disabled value={data[ABBREVIATION] ?? null} />
        </FormItem>
        <FormItem icon={faLocationArrow} label='common.address.dd'>
          <Input disabled value={data[ADDRESS] ?? null} />
        </FormItem>
      </div>
    </>
  )
}

export default SchoolSelector
